import { jsx as _jsx } from "react/jsx-runtime";
export const BrandBadge = ({ className = '' }) => {
    return (_jsx("span", { className: `w-8 h-8 rounded-lg flex items-center justify-center text-white font-bold text-lg ${className}`, style: { backgroundColor: 'var(--color-primary, rgb(13 148 136))' }, children: "B" }));
};
//# sourceMappingURL=BrandBadge.js.map